module.exports = __webpack_public_path__ + "img/app_food_text_th.4e70e2ec.png";